// Document version constants
// Update these dates when terms or privacy policy change
export const DOCUMENT_VERSIONS = {
  terms: "2024-01-15",
  privacy: "2024-01-15"
} as const;

export type DocumentType = keyof typeof DOCUMENT_VERSIONS;
